<script setup>
import { usehistorialDeOfertasStore } from "@/store/historialDeOfertasStore";
import { ref } from "vue";

const historialDeOfertasStore = usehistorialDeOfertasStore();

const subastaExternalId = ref("");

function buscarPorIdSubasta() {
  historialDeOfertasStore.obtenerOfertasUsuario(
    historialDeOfertasStore.selected_tab?.estado,
    { page: 1, subasta_external_id: subastaExternalId.value }
  );
}
</script>

<template>
  <div>
    <div
      class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-end mb-5 me-0 gap-2 gap-md-0"
    >
      <div
        class="d-flex flex-column flex-md-row align-items-start align-items-md-center w-100 w-md-auto"
      >
        <span
          class="mb-1 mb-md-0 pe-md-2 bloque_busqueda_lote_label text-soft-grey-74 fw-500"
        >
          Buscar por ID
        </span>

        <div class="input-group w-100 w-md-auto">
          <span class="input-group-text bg-soft-grey-ee border-0">
            <i class="fa-solid fa-magnifying-glass"></i>
          </span>
          <input
            type="text"
            class="form-control bg-soft-grey-ee border-0 rounded-2 input-buscador"
            v-model="subastaExternalId"
            @keyup.enter="buscarPorIdSubasta"
          />
        </div>
      </div>

      <div
        class="d-flex justify-content-end w-100 w-md-auto"
        v-if="historialDeOfertasStore.selected_pujas.length > 0"
      >
        <div
          class="d-flex flex-column justify-content-end flex-md-row me-2 align-items-start align-items-md-center w-100 w-md-auto"
        >
          <p class="mb-1 mb-md-0 me-md-2 fw-600 text-soft-grey-74">
            Seleccionar CUIT
          </p>

          <select
            class="form-select boton_opcion rounded-2 border-soft-grey w-100 w-md-50"
            v-model.number="historialDeOfertasStore.selected_cuit"
          >
            <option :value="null">No Seleccionado</option>
            <option
              v-for="dato in historialDeOfertasStore.datos_facturacion"
              :key="dato.id"
              :value="dato.id"
            >
              {{ dato.cuit_cuil }}
            </option>
          </select>
        </div>

        <div
          class="d-flex flex-column justify-content-end flex-md-row me-2 align-items-start align-items-md-center w-100 w-md-auto"
        >
          <p
            class="d-sm-none mb-1 mb-md-0 me-md-2 fw-600 text-soft-grey-74 invisible"
          >
            Espacio para acomodar
          </p>
          <button
            class="btn btn-soft-green w-100 w-md-auto"
            @click="
              historialDeOfertasStore.asignarIdPerfilFacturacionALoteMasivo
            "
          >
            Asignar CUIT
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.bloque_busqueda_lote_label {
  min-width: 80px;
  max-width: 120px;
}

/* Corregido: 310px (antes 310x) */
.bloque_busqueda_lote {
  max-width: 310px;
  min-width: 100px;
}

.input-wrapper {
  position: relative;
  display: inline-block;
  width: 250px;
}

.input-wrapper input {
  width: 100%;
  padding: 8px 12px 8px 35px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
}

.input-wrapper i {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #888;
  pointer-events: none;
}

.boton_opcion {
  background-color: transparent !important;
}
</style>
